import React from "react";
import ReactDOM from "react-dom/client"; // Change import to use 'react-dom/client'
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import App from "./App";
import "./index.css"; // Assuming you have a CSS file for styles

// Create a root to render your App
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the App within BrowserRouter
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
